// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tamyr_content__wq5\\+A {
  margin-top: 70px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
}

.tamyr_block__zBfW\\+ {
  max-height: 650px;
  height: 650px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  padding: 6px 20px 26px;
  overflow: hidden;
}
.tamyr_block__zBfW\\+ > img {
  z-index: 1;
}
.tamyr_block_text__WxZYm {
  font-weight: 500;
  margin-bottom: 24px;
  border-radius: 11px;
  padding: 10px 12px;
  font-size: 1.25vw;
  line-height: 22px;
  font-family: var(--font-rubik);
  max-height: 200px;
  height: 100%;
  width: 100%;
}

.tamyr_block_pink__IvJtX {
  border: 6px solid #FFD4FD;
  background: linear-gradient(to bottom, #FFD6F1 0%, #D4578C 65%, #D8AAE4 100%);
}
.tamyr_block_pink_text_pink__RWIVs {
  background-color: #F7C9F0;
}

.tamyr_block_green__ehWEP {
  border: 6px solid #D4FFD9;
  background: linear-gradient(to bottom, #AFFFB7 0%, #5AD567 65%, #8CED95 100%);
}
.tamyr_block_green_text_green__\\+esdj {
  background-color: #E0DBE2;
}

.tamyr_block_yellow__boi2G {
  border: 6px solid #FFF8C7;
  background: linear-gradient(to bottom, #ECE7BF 0%, #E2D46F 100%);
}
.tamyr_block_yellow_text_yellow__DlZ30 {
  background-color: #FADBE9;
}

.tamyr_round__Nluie {
  width: 200em;
  height: 200em;
  border-radius: 50%;
  position: absolute;
  top: -194.5em;
}

.tamyr_round_pink__MfHCu {
  background: linear-gradient(to top, #D44668 0%, #D44668 2%, #FFBEF9 2.6%, #FFBEF9 100%);
  border: 4px solid #DB7ECC;
}

.tamyr_round_green__SAAlb {
  background: linear-gradient(to top, #3EA449 0%, #3EA449 2%, #BEFFC5 2.6%, #BEFFC5 100%);
  border: 4px solid #7EDB88;
}

.tamyr_round_yellow__JzZPB {
  background: linear-gradient(to top, #F7931D 0%, #F7931D 2%, #FFD596 2.6%, #FFD596 100%);
  border: 4px solid #F6E865;
}

.tamyr_tamyrlogo__TEbuT {
  background-color: white;
  border-radius: 50%;
  width: 134px;
  height: 134px;
  padding: 11px;
  margin-top: 34px;
  margin-bottom: 15px;
}
.tamyr_tamyrlogo__TEbuT img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tamyr_orange_button__lpXmH {
  padding: 16px 76px;
}

@media screen and (max-width: 1300px) {
  .tamyr_content__wq5\\+A {
    margin-top: 48px;
    display: flex;
    flex-direction: column;
  }
  .tamyr_block__zBfW\\+ {
    width: 100%;
  }
  .tamyr_block_text__WxZYm {
    font-size: 18px;
    line-height: 22px;
  }
}
@media screen and (max-width: 768px) {
  .tamyr_content__wq5\\+A {
    margin-top: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/tamyr/tamyr.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,kCAAA;EACA,SAAA;AACF;;AAEA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AACF;AAAE;EACE,UAAA;AAEJ;AAAE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,8BAAA;EAEA,iBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAGA;EACE,yBAAA;EACA,6EAAA;AAAF;AACE;EACE,yBAAA;AACJ;;AAGA;EACE,yBAAA;EACA,6EAAA;AAAF;AACE;EACE,yBAAA;AACJ;;AAGA;EACE,yBAAA;EACA,gEAAA;AAAF;AACE;EACE,yBAAA;AACJ;;AAGA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AAAF;;AAGA;EACE,uFAAA;EACA,yBAAA;AAAF;;AAGA;EACE,uFAAA;EACA,yBAAA;AAAF;;AAGA;EACE,uFAAA;EACA,yBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAAF;AACE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AACJ;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE;IACE,gBAAA;IACA,aAAA;IACA,sBAAA;EAAF;EAGA;IACE,WAAA;EADF;EAIA;IACE,eAAA;IACA,iBAAA;EAFF;AACF;AAKA;EACE;IACE,gBAAA;EAHF;AACF","sourcesContent":[".content {\n  margin-top: 70px;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 20px;\n}\n\n.block {\n  max-height: 650px;\n  height: 650px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 25px;\n  padding: 6px 20px 26px;\n  overflow: hidden;\n  & > img {\n    z-index: 1;\n  }\n  &_text {\n    font-weight: 500;\n    margin-bottom: 24px;\n    border-radius: 11px;\n    padding: 10px 12px;\n    font-size: 1.25vw;\n    line-height: 22px;\n    font-family: var(--font-rubik);\n    //height: 152px;\n    max-height: 200px;\n    height: 100%;\n    width: 100%;\n  }\n}\n\n.block_pink {\n  border: 6px solid #FFD4FD;\n  background: linear-gradient(to bottom, #FFD6F1 0%, #D4578C 65%, #D8AAE4 100%);\n  &_text_pink {\n    background-color: #F7C9F0;\n  }\n}\n\n.block_green {\n  border: 6px solid #D4FFD9;\n  background: linear-gradient(to bottom, #AFFFB7 0%, #5AD567 65%, #8CED95 100%);\n  &_text_green {\n    background-color: #E0DBE2;\n  }\n}\n\n.block_yellow {\n  border: 6px solid #FFF8C7;\n  background: linear-gradient(to bottom, #ECE7BF 0%, #E2D46F 100%);\n  &_text_yellow {\n    background-color: #FADBE9;\n  }\n}\n\n.round {\n  width: 200em;\n  height: 200em;\n  border-radius: 50%;\n  position: absolute;\n  top: -194.5em;\n}\n\n.round_pink {\n  background: linear-gradient(to top, #D44668 0%, #D44668 2%, #FFBEF9 2.6%, #FFBEF9 100%);\n  border: 4px solid #DB7ECC;\n}\n\n.round_green {\n  background: linear-gradient(to top, #3EA449 0%, #3EA449 2%, #BEFFC5 2.6%, #BEFFC5 100%);\n  border: 4px solid #7EDB88;\n}\n\n.round_yellow {\n  background: linear-gradient(to top, #F7931D 0%, #F7931D 2%, #FFD596 2.6%, #FFD596 100%);\n  border: 4px solid #F6E865;\n}\n\n.tamyrlogo {\n  background-color: white;\n  border-radius: 50%;\n  width: 134px;\n  height: 134px;\n  padding: 11px;\n  margin-top: 34px;\n  margin-bottom: 15px;\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.orange_button {\n  padding: 16px 76px;\n}\n\n@media screen and (max-width: 1300px) {\n  .content {\n    margin-top: 48px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .block {\n    width: 100%;\n  }\n\n  .block_text {\n    font-size: 18px;\n    line-height: 22px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .content {\n    margin-top: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `tamyr_content__wq5+A`,
	"block": `tamyr_block__zBfW+`,
	"block_text": `tamyr_block_text__WxZYm`,
	"block_pink": `tamyr_block_pink__IvJtX`,
	"block_pink_text_pink": `tamyr_block_pink_text_pink__RWIVs`,
	"block_green": `tamyr_block_green__ehWEP`,
	"block_green_text_green": `tamyr_block_green_text_green__+esdj`,
	"block_yellow": `tamyr_block_yellow__boi2G`,
	"block_yellow_text_yellow": `tamyr_block_yellow_text_yellow__DlZ30`,
	"round": `tamyr_round__Nluie`,
	"round_pink": `tamyr_round_pink__MfHCu`,
	"round_green": `tamyr_round_green__SAAlb`,
	"round_yellow": `tamyr_round_yellow__JzZPB`,
	"tamyrlogo": `tamyr_tamyrlogo__TEbuT`,
	"orange_button": `tamyr_orange_button__lpXmH`
};
export default ___CSS_LOADER_EXPORT___;
